import { loadStripe } from "@stripe/stripe-js";
import { useMemo } from "react";

export function useConnectedStripe(stripeAccountId?: string | null) {
	return useMemo(() => {
		if (!stripeAccountId) return null;
		return loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY as unknown as string, {
			stripeAccount: stripeAccountId,
		});
	}, [stripeAccountId]);
}
